import { render, staticRenderFns } from "./CustomerViewInfo.vue?vue&type=template&id=1959a031&scoped=true"
import script from "./CustomerViewInfo.vue?vue&type=script&lang=js"
export * from "./CustomerViewInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959a031",
  null
  
)

export default component.exports